import React from "react";
// error
import { onError } from "../../../../features/error/error.tsx";
// calendar
// @ts-ignore
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
// image
import ImageUploading from 'react-images-uploading';
// map 
import Mapir from "mapir-react-component";
import 'mapbox-gl/dist/mapbox-gl.css';
import { Map } from "../../../../features/map/mapToken.tsx";
// datePicker
import { handleChange } from "../../../../features/datePicker/datePickerChange.tsx";
// controller
import { PhotoCreateOrUpdate } from "../../../../controllers/admin/photographer/photoCreateOrUpdate.tsx";
// Loading
import Loading from "../../../../components/childrens/loading/loading.tsx";


const CreateUpdatePhotographer = () => {
    const { isLoading, id, register, handleSubmit, coord, maxNumber, onChange, pending, pendingUpdate, onSubmit, reverseFunction, value, setValue, markerRef, address, images } = PhotoCreateOrUpdate();
    return (
        <>
            <section>
                {/* admin page component */}
                <div className={'admin-page-content mb-3 pt-0'}>
                    <div id={'admin-page-form'}>
                        <p className={'fw-bold box-title'}>
                            {id ? 'ویرایش عکاس' : 'ایجاد عکاس'}
                        </p>
                        <div className={'card card-body shadow border-0'}>
                            {!isLoading ?
                                (
                                    <>
                                        <form onSubmit={handleSubmit(onSubmit, onError)}>
                                            <div className="row align-items-center gy-4">
                                                <div className="col-md-9">
                                                    <fieldset className='form-floating'>
                                                        <input
                                                            type='text'
                                                            placeholder='نام , نام خانوادگی'
                                                            className='form-control'
                                                            {...register('full_name', { required: 'فیلد نام و نام خانوادگی الزامی است' })}
                                                        />
                                                        <label className='form-label'>
                                                            نام و نام خانوادگی
                                                        </label>
                                                    </fieldset>
                                                    <fieldset className='form-floating mt-4'>
                                                        <input
                                                            type='tel'
                                                            placeholder='تلفن همراه'
                                                            className='form-control'
                                                            {...register('cellphone', { required: 'فیلد تلفن همراه الزامی است' })}
                                                        />
                                                        <label className='form-label'>
                                                            تلفن همراه
                                                        </label>
                                                    </fieldset>
                                                    <fieldset className="form-floating mt-4">
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            placeholder="ایمیل"
                                                            {...register('email', { required: 'فیلد ایمیل الزامی است' })}
                                                        />
                                                        <label >ایمیل</label>
                                                    </fieldset>
                                                </div>
                                                <div className="col-md-3">
                                                    <ImageUploading
                                                        multiple
                                                        value={images}
                                                        onChange={onChange}
                                                        maxNumber={maxNumber}
                                                        dataURLKey="data_url"
                                                    >
                                                        {({
                                                            imageList,
                                                            onImageUpdate,
                                                        }) => (
                                                            // write your building UI
                                                            <div className="upload__image-wrapper">
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <div className="card img-uploader-card card-body border-0">
                                                                            {imageList.map((image, index) => (
                                                                                <div className="d-flex justify-content-center"
                                                                                    key={index}>
                                                                                    <div className="image-item">
                                                                                        <img src={image['data_url']} alt="upload"
                                                                                            className="img-fluid image-upload-done-b mt-3 mb-2" />
                                                                                        <div className="image-item__btn-wrapper">
                                                                                            <button
                                                                                                type="button"
                                                                                                className="upload-btn rounded rounded-4 px-4"
                                                                                                onClick={() => onImageUpdate(index)}>
                                                                                                بروزرسانی و آپلود
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </ImageUploading>
                                                </div>
                                                <div className="col-md-6">
                                                    <fieldset className='form-floating'>
                                                        <input
                                                            type='tel'
                                                            placeholder='کدملی'
                                                            className='form-control'
                                                            {...register('national_code', { required: 'فیلد کدملی الزامی است' })}
                                                        />
                                                        <label className='form-label'>
                                                            کدملی
                                                        </label>
                                                    </fieldset>
                                                </div>
                                                <div className="col-md-6">
                                                    <fieldset className='form-floating'>
                                                        <input
                                                            type='text'
                                                            placeholder='نام کاربری'
                                                            className='form-control'
                                                            {...register('username', { required: true, })}
                                                        />
                                                        <label className='form-label'>
                                                            نام کاربری
                                                        </label>
                                                    </fieldset>
                                                </div>
                                                <div className="col-md-6">
                                                    <fieldset className='form-floating'>
                                                        <input
                                                            type='text'
                                                            placeholder='رمزورود'
                                                            className='form-control'
                                                            {...register('password', { required: true, })}
                                                        />
                                                        <label className='form-label'>
                                                            رمزورود
                                                        </label>
                                                    </fieldset>
                                                </div>
                                                <div className="col-md-6">
                                                    <fieldset className="form-floating">
                                                        <DatePicker
                                                            value={value}
                                                            placeholder={'تاریخ تولد'}
                                                            calendar={persian}
                                                            locale={persian_fa}
                                                            onChange={(value) => handleChange(value, setValue)}
                                                        />
                                                    </fieldset>
                                                </div>
                                                <div className="col-md-6 position-relative">
                                                    <Mapir center={coord} Map={Map} onClick={reverseFunction}></Mapir>
                                                    <div ref={markerRef} className="marker"></div>
                                                </div>
                                                <div className="col-md-6">
                                                    <fieldset className='form-floating'>
                                                        <textarea
                                                            placeholder='آدرس'
                                                            className='form-control'
                                                            value={address}
                                                        />
                                                        <label className='form-label'>
                                                            آدرس
                                                        </label>
                                                    </fieldset>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end">
                                                <button disabled={id ? pendingUpdate : pending} className='btn btn-outline-primary mt-4'>
                                                    {pendingUpdate || pending ? 'در حال ارسال ...' : 'ارسال'}
                                                </button>
                                            </div>
                                        </form>
                                    </>
                                )
                                :
                                (
                                    <>
                                        <Loading />
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CreateUpdatePhotographer;